import {BiMessageAlt} from 'react-icons/bi';
import {MdWeb} from 'react-icons/md';
import {BsBoundingBoxCircles} from 'react-icons/bs';
export const signupList = [
    {
        icon:<BiMessageAlt />,
        title:"Collaboration",
        desc:"Clients and colleagues can add comments directly on designs."
    },
    {
        icon:<MdWeb />,
        title:"Wireframing",
        desc:"Create and share simple wireframes of websites and mobile apps."
    },
    {
        icon:<BsBoundingBoxCircles/>,
        title:"Prototyping",
        desc:"Transform your design and wireframes into clickable, interactive prototypes."
    }
]